import React, { useState } from 'react'
import { Button, Card, Col, Form, Row, Container, Image } from 'react-bootstrap'
import Spinner from 'react-spinkit'
import { useHistory } from 'react-router'
import { handleCancel, handleSubmit, onChange, onImageChange } from './profile.utils'
export const ProfileCard = (props) => {
    const [user, setUser] = useState(props.user)
    const [loading, setLoading] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)

    return (
        <Container fluid className='mx-0 p-0'>

            <Card>

                <Card.Header>
                    Your Profile
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col sm={4} md={3} lg={3} xl={2} >
                            {loading ? <Spinner className="d-flex flex-wrap align-items-center mx-0 px-0" name='ball-pulse-sync' />
                                : <>
                                    <Row className='d-flex justify-content-center align-items-center'>

                                        <Image src={user.image} className='p-3' style={{ maxHeight: '400px', width: 'auto' }} />
                                    </Row>

                                    <Row className='d-flex justify-content-center align-items-center'>
                                        <Col xs={12} className='d-flex justify-content-center align-items-center'>
                                            <Form>
                                                <label className='btn btn-primary' htmlFor='profilePicture'>Change</label>
                                                <input id='profilePicture' type='file' accept="image/*" onChange={async (e) => {
                                                    setLoading(true)
                                                    const newUser = await onImageChange(e, user, e.target.files[0])

                                                    if (newUser != "Error") {

                                                        await handleSubmit(e, newUser, true)
                                                        
                                                    }
                                                    setLoading(false)
                                                    props.toggleLoading()

                                                }

                                                } style={{ display: 'none' }}></input>
                                            </Form>
                                        </Col>
                                    </Row>
                                </>}
                        </Col>
                        <Col sm={8} md={6} lg={6} xl={4} >
                            {loading ? <Spinner className="d-flex flex-wrap align-items-center mx-0 px-0" name='ball-pulse-sync' />
                                : <>
                                    <Row className='d-flex justify-content-center align-items-center py-3'>

                                        <Form onSubmit={async (e) => {
                                            setLoading(true)
                                            await handleSubmit(e, user, false)
                                            setLoading(false)
                                            props.toggleLoading()
                                            props.toggleEdit()
                                        }}>
                                            <Row className="mb-3">
                                                <Col sm={6} className='py-2'>
                                                    <Form.Label>First Name</Form.Label>
                                                    <Form.Control

                                                        onChange={(e) => setUser(onChange(e, user))}
                                                        type="text"
                                                        required
                                                        placeholder="First Name"
                                                        value={user.firstName}
                                                        name='firstName'
                                                        disabled={!props.isEditMode}
                                                    />
                                                </Col>
                                                <Col sm={6} className='py-2'>
                                                    <Form.Label>Last Name</Form.Label>
                                                    <Form.Control

                                                        onChange={(e) => setUser(onChange(e, user))}
                                                        type="text"
                                                        required
                                                        placeholder="Last Name"
                                                        value={user.lastName}
                                                        name='lastName'
                                                        disabled={!props.isEditMode}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col sm={12} className='py-2'>
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control

                                                        onChange={(e) => setUser(onChange(e, user))}
                                                        type="text"
                                                        required
                                                        placeholder="Email"
                                                        value={user.email}
                                                        name='email'
                                                        disabled={!props.isEditMode}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col sm={12} className='py-2'>
                                                    <Form.Label>About You</Form.Label>
                                                    <Form.Control

                                                        onChange={(e) => setUser(onChange(e, user))}
                                                        as="textarea"
                                                        rows={4}
                                                        required
                                                        placeholder="Description"
                                                        value={user.description}
                                                        name='description'
                                                        disabled={!props.isEditMode}
                                                    />
                                                </Col>
                                            </Row>
                                            {props.isEditMode
                                                ?
                                                <Row className='d-flex justify-content-center align-items-center mb-3'>
                                                    <Col sm={12} className='d-flex justify-content-center align-items-center'>
                                                        <Button type="submit">Submit</Button>
                                                    </Col>
                                                </Row>
                                                : ""}

                                        </Form>
                                    </Row>


                                </>}
                        </Col>

                    </Row>


                </Card.Body>
                <Card.Footer>
                    <Button onClick={(e) => {
                        if (props.isEditMode) {
                            props.toggleLoading()
                        }
                        props.toggleEdit()



                    }}
                    >{props.isEditMode ? "Cancel" : "Edit"}</Button>
                </Card.Footer>
            </Card>


        </Container>
    )
}
